transformCache